import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getFaqWithId } from "../../redux/templete/authSlice";
import parse from "html-react-parser";
function HelpArticleModal() {
  const { userFaq } = useSelector((state) => state.authReducer);
  const { a } = useParams();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: "auth/resetDetail" });
    dispatch(getFaqWithId(a));
  }, [dispatch, a]);
  return (
    <div className="py-14 px-2">
      {userFaq !== null &&
        userFaq[0].description &&
        parse(userFaq[0].description)}
    </div>
  );
}

export default HelpArticleModal;
